import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'leafPath'
})
export class LeafPathPipe implements PipeTransform {

  public transform(item: any, itemTextField: string = 'name'): string {
    if (!item) return '';
    return LeafPathPipe.leafPath(item, itemTextField);
  }

  static leafPath(item: any, itemTextField: string = 'name'): string {
    return itemTextField.split('.').reduce((value, el) => value[el], item);
  }

}
